<template>
  <div class="tabbed-content-container">
    <TabComponent
      :tabTitles="tabTitles"
      @tabSelected="tabSelected"
      :activeTab="activeTab"
    />
    <transition
      name="fade"
      mode="out-in"
      @before-enter="beforeEnter"
      @after-leave="afterLeave"
    >
      <div :key="currentActiveTab" class="content-container">
        <section>
          <slot v-if="currentActiveTab == 0" name="tab-zero"> </slot>
        </section>
        <section>
          <slot v-if="currentActiveTab == 1" name="tab-one"></slot>
        </section>
        <section>
          <slot v-if="currentActiveTab == 2" name="tab-two"> </slot>
        </section>
        <section>
          <slot v-if="currentActiveTab == 3" name="tab-three"> </slot>
        </section>
        <section>
          <slot v-if="currentActiveTab == 4" name="tab-four"> </slot>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
  import Tabs from './Tabs.vue';
  export default {
    name: 'TabbedContentComponent',
    data() {
      return {
        isTransitioning: false,
      };
    },
    components: {
      Tabs,
    },
    props: {
      tabTitles: {
        required: true,
        default: [],
        type: Array,
      },
    },
    data() {
      return {
        internalActiveTab: 0,
        isTransitioning: false,
        userHasInteracted: false,
      };
    },
    props: {
      tabTitles: {
        required: true,
        default: [],
        type: Array,
      },
      activeTab: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      currentActiveTab() {
        // If user has interacted with tabs, use internal state
        // Otherwise, use prop value if provided
        return this.userHasInteracted ? this.internalActiveTab : this.activeTab;
      },
    },
    methods: {
      tabSelected(tab) {
        this.internalActiveTab = tab;
        this.userHasInteracted = true;
        this.$emit('tab-changed', tab);
      },
      beforeEnter() {
        this.isTransitioning = true;
      },
      afterLeave() {
        this.isTransitioning = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content-container {
    // width: clamp(300px, 95%, 1600px);
    width: 100%;
    min-width: 100%;
  }
  .tabbed-content-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tabbed-content-tabs {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      margin-bottom: 48px;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.222s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
